export * from './ellipsis.component';
export * from './ellipsis.module';
